import { Center, Tag, Text, VStack } from "@chakra-ui/react"
import { FhResponseData } from "../../../../../../common/types/search"
import CustomImage from "../../../../../shared/CustomImage"
import { CClose } from "../../../../../shared/Icons"
import OverflowingText from "../../../../../shared/OverflowingText"

type Props = {
  category: FhResponseData
  handleCategorySelect: (_urlParams: string, categoryValue: string, isActive: boolean) => void
}

export const UpperLevelCategoryTile = ({ category, handleCategorySelect }: Props) => {
  const { link, nr, value, _imageurl } = category
  const isActive = category?.selected === true
  const categoryValue = value.value
  const categoryUrlParams = link.url_params

  return (
    <VStack
      as="article"
      position="relative"
      w="46"
      h="46"
      spacing="0"
      outline="1px solid"
      outlineColor={isActive ? "black" : "gray.350"}
      _hover={{ outlineColor: isActive ? "black" : "gray.500", cursor: "pointer" }}
      _active={{ outlineColor: isActive ? "gray.500" : "gray.900" }}
      onClick={() => handleCategorySelect(categoryUrlParams, categoryValue, isActive)}
    >
      <Center pt="3.5" w="100%">
        <CustomImage src={_imageurl} alt={link.name} w="30" h="30" loading="eager" />
      </Center>
      <Center px="2" h="100%" w="100%">
        <OverflowingText text={link.name} />
      </Center>
      {isActive ? (
        <Center borderRadius="full" bgColor="gray.200" position="absolute" top="2" right="2" w="6" h="6">
          <CClose boxSize="2.5" stroke="gray.900" strokeWidth="1.75" />
        </Center>
      ) : (
        <Tag borderRadius="full" bgColor="gray.200" position="absolute" top="2" right="2">
          <Text color="gray.900" fontSize="xs" fontWeight="medium">
            {nr}
          </Text>
        </Tag>
      )}
    </VStack>
  )
}
